import { useRef, useEffect } from 'react';

/**
 * An abstraction on top of `useRef` that keeps track of the previous value.
 * @param value - The current value.
 * @returns The previous value.
 */
function usePrevious(value) {
  const ref = useRef();
  useEffect(() => {
    ref.current = value;
  }, [value]);
  return ref.current;
}

export { usePrevious as default };
